import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'theme/withStyles';
import RawHtml from 'common/RawHtml';

const styles = (theme) => {
  const { spacing, typography } = theme;
  return {
    label: {
      ...typography.h3,
      display: 'inline-block',
      marginBottom: spacing.unit * 2,
      marginLeft: spacing.unit * 2,
      paddingRight: 70,
      position: 'relative',
      top: 2,
    },
  };
};

const Label = ({ classes, label }) => (
  <RawHtml type="h3" className={classes.label}>
    {label}
  </RawHtml>
);

Label.propTypes = {
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(Label);
